/**
 * Exact inverse of `toBackendDateFormat`, which stores a picked day as UTC midnight of the day's
 * *local* calendar parts (`2026-04-01` → `2026-04-01T00:00:00.000Z`).
 *
 * Reading such a value back with a bare `new Date(...)` yields 31 March 19:00 for a UTC-5 user, so
 * `date-fns` `format` renders the day before the one that was saved, the date picker hydrates on
 * it, and saving again stores that earlier day — one day of drift per open-and-save. Rebuilding the
 * date from its UTC parts at local midnight makes the round trip stable in every timezone.
 *
 * For backend-sourced day values only. A `Date` that already came from a picker is local already
 * and must not be passed through this.
 */
export const fromBackendDateFormat = (value: Date | number | string): Date => {
  const stored = new Date(value);

  if (Number.isNaN(stored.getTime())) return stored;

  return new Date(stored.getUTCFullYear(), stored.getUTCMonth(), stored.getUTCDate());
};
